
import { UserData, ForgivenessProgram, ProgramStatus } from '../types';

const allPrograms = {
  pslf: {
    id: 'pslf',
    name: 'Public Service Loan Forgiveness (PSLF)',
    description: 'Forgives the remaining balance on your Direct Loans after you have made 120 qualifying monthly payments under a qualifying repayment plan while working full-time for a qualifying employer.',
    status: 'action-required' as ProgramStatus,
    estimatedSavings: 'Up to Full Balance',
    estimatedSavingsValue: 0, // Not used for calculation, but for sorting/logic
    submissionType: 'electronic' as 'electronic' | 'manual',
    processingTime: '2-6 months',
  },
  tpd: {
    id: 'tpd',
    name: 'Total and Permanent Disability (TPD) Discharge',
    description: 'Relieves you from having to repay your federal student loans if you\'re totally and permanently disabled.',
    status: 'action-required' as ProgramStatus,
    estimatedSavings: 'Full Balance',
    estimatedSavingsValue: 0,
    submissionType: 'manual' as 'electronic' | 'manual',
    processingTime: '1-6 months',
  },
  idr: {
    id: 'idr',
    name: 'IDR Account Adjustment & SAVE Plan',
    description: 'A one-time adjustment of payment counts for borrowers on Income-Driven Repayment plans. The SAVE plan offers lower monthly payments and earlier forgiveness for many.',
    status: 'action-required' as ProgramStatus,
    estimatedSavings: 'Significant Savings',
    estimatedSavingsValue: 15000, // Average representative value
    submissionType: 'electronic' as 'electronic' | 'manual',
    processingTime: '2-6 months',
  }
};

export const determineEligibility = (data: UserData): ForgivenessProgram[] => {
  const eligiblePrograms: ForgivenessProgram[] = [];

  // PSLF Logic
  if ((data.employmentType === 'public' || data.employmentType === 'non-profit') && data.yearsInPublicService >= 1) {
    eligiblePrograms.push({
      ...allPrograms.pslf,
    });
  }

  // TPD Discharge Logic
  if (data.hasDisability) {
    eligiblePrograms.push({
        ...allPrograms.tpd,
    });
  }

  // IDR Adjustment Logic
  if (data.onIDR) {
    eligiblePrograms.push(allPrograms.idr);
  }
  
  // Make sure at least one program is always eligible if they have a loan and are employed
  if(eligiblePrograms.length === 0 && data.employmentType !== 'not-employed') {
    eligiblePrograms.push(allPrograms.idr);
  }


  return eligiblePrograms;
};